import { trackUpgradeClicked } from '@sparklayer-io/spark-dash-core/lib/mixpanel';
import { Upsell } from '@sparklayer-io/spark-dash-pages/components/upsell';
import { useHandlers, useSite } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { Card } from '@ui/themed';
import { t } from 'i18next';
import { I18N_PAGE, SALES_AGENT_ORDERING_URL } from '../constants';

export function SalesAgentsUpsell() {
  const site = useSite();
  const { navigationHandler } = useHandlers();

  const useCases = [
    {
      key: 'place_orders',
      title: t(`${I18N_PAGE}.upsell.use_cases.place_orders.title`),
      description: t(`${I18N_PAGE}.upsell.use_cases.place_orders.description`),
    },
    {
      key: 'offline_orders',
      title: t(`${I18N_PAGE}.upsell.use_cases.offline_orders.title`),
      description: t(`${I18N_PAGE}.upsell.use_cases.offline_orders.description`),
    },
    {
      key: 'reorder',
      title: t(`${I18N_PAGE}.upsell.use_cases.reorder.title`),
      description: t(`${I18N_PAGE}.upsell.use_cases.reorder.description`),
    },
  ];

  return (
    <Card>
      <Upsell
        title={t(`${I18N_PAGE}.upsell.title`)}
        subtitle={t(`${I18N_PAGE}.upsell.subtitle`)}
        imageType="salesAgent"
        plans={['v2_basic']}
        onClickUpgrade={() => {
          trackUpgradeClicked(site, 'Sales Agents');
          navigationHandler.navigateById('plan');
        }}
        onClickLearn={() =>
          navigationHandler.navigate(SALES_AGENT_ORDERING_URL, { absolute: true, newTab: true })
        }
        details={{
          use_cases: useCases,
        }}
      />
    </Card>
  );
}
